import { translateBackend } from '@assets/i18n/config';
import { Icon } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Grid } from '@ovComponents/1-primative/grid/grid';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useTabNavTokens } from '@ovComponents/3-pattern/tabNav/tabNav.tokens';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { InlineImage } from '@pages/client/components/documents/inlineImage';
import { InlineImageLocal } from '@pages/client/components/documents/inlineImageLocal';
import { AnalyticsContext } from '@providers/analyticsProvider';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { ovAnalyticsEvents } from '@utils/analytics/analytics';
import { kebabCase } from 'lodash-es';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const ReviewVisual = ({
  options,
  loading,
  continueFunc,
}: {
  options: any;
  loading: boolean;
  continueFunc: any;
}) => {
  const { t } = useTranslation(['workflowCompletions']);
  const tokens = useThemeTokens(useTabNavTokens());
  const { sendAnalytic } = useContext(AnalyticsContext);
  const { comp } = tokens;
  const submit = async () => {
    sendAnalytic(ovAnalyticsEvents.workflowsReviewContinueButtonSelect);
    await continueFunc();
  };

  const styles: any = {
    objectFit: 'cover',
    minHeight: '60px',
    width: '80px',
    borderRadius: '15px',
  };

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      submitButtonProps={{
        dataTestId: `review-${kebabCase(options?.title?.en)}-continue-button`,
        label: t('workflowCompletions:continue'),
        disabled: loading,
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 5 }}>
        <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
          {translateBackend(options?.subtitle)}
        </ReactMarkdown>
      </Typography>
      {options?.options?.map((option: any) => (
        <Box
          display='flex'
          mb={5}
          sx={{ opacity: option.state === 'DISABLED' ? 0.4 : 1 }}
        >
          {option?.value?.file && (
            <Box mr={2}>
              <InlineImageLocal file={option?.value?.file} style={styles} />
            </Box>
          )}
          {option?.value?.value && (
            <Box mr={2}>
              <InlineImage
                fileDocumentId={option?.value?.value}
                style={styles}
              />
            </Box>
          )}
          <Grid container xs={12}>
            <Grid item xs={option?.icon ? 11 : 12}>
              <Box>
                <Typography variant='headingSmall' mb={0.5}>
                  {translateBackend(option.title)}
                </Typography>
                <Typography variant='bodyLarge'>
                  {translateBackend(option.subtitle)}
                </Typography>
              </Box>
            </Grid>
            {option?.icon ? (
              <Grid item ml='auto' xs={option.trailing ? 1 : 0}>
                <Icon sx={{ fontSize: '30px', color: comp.tabNav.text.active }}>
                  {option.icon}
                </Icon>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      ))}
    </WorkflowCompletionForm>
  );
};

export default ReviewVisual;
